import { inject } from "@angular/core";
import { CanActivateFn, RedirectCommand, Router } from "@angular/router";
import { LoginService } from "@dert-services";
import { AuthorizationPolicy, isAuthorizedForPolicy } from "./authorization-policy";

export const authGuard: CanActivateFn = (route, state) => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  if (!loginService?.loggedIn || !loginService?.user) {
    const unauthorizedUrl = router.parseUrl("/unauthorized");
    return new RedirectCommand(unauthorizedUrl);
  }

  const policy = route.data?.authorizationPolicy as AuthorizationPolicy | undefined;
  if (!isAuthorizedForPolicy(loginService.user.Roles, policy)) {
    const forbiddenUrl = router.parseUrl("/forbidden");
    return new RedirectCommand(forbiddenUrl);
  }

  return true;
};
